import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/jacui-logo 1 (2).svg";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleProdutosClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (window.location.pathname !== "/home") {
      navigate("/home");
      // Aguarda a renderização da home para realizar o scroll
      setTimeout(() => {
        const produtosSection = document.getElementById("produtos");
        if (produtosSection) {
          produtosSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const produtosSection = document.getElementById("produtos");
      if (produtosSection) {
        produtosSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // URL do WhatsApp com mensagem pré-definida (encode a mensagem)
  const whatsappUrl =
    "https://wa.me/5541998769002?text=" +
    encodeURIComponent("Olá, tenho interesse na compra do mel");

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-container">
          <NavLink to="/home" onClick={() => setMenuOpen(false)}>
            <img src={logo} alt="Logo" className="logo" />
          </NavLink>
        </div>
        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                to="/home"
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              {/* Link para produtos com scroll suave */}
              <a
                href="/home#produtos"
                onClick={handleProdutosClick}
                className="nav-link"
              >
                Produtos
              </a>
            </li>
            <li className="nav-item">
              {/* Link de contato direciona para o WhatsApp com mensagem */}
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
                onClick={() => setMenuOpen(false)}
              >
                Contato
              </a>
            </li>
          </ul>
        </nav>
        {/* Botão do menu hambúrguer */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="right-placeholder" />
      </div>
    </header>
  );
};

export default Header;
